<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import DynamicComponentActionElement from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";
import {
  ENGAGEMENT_ICONS,
  EngagementActionMixin,
} from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";
import ButtonActionOptions from "%/dynamic-component-editor/bundles/button-action-options";
import {
  SHARE_CONFIRMATION_MS,
  shareStory,
} from "%/dynamic-component-editor/standard-components/base-story-card/story-engagement-actions";

export default {
  name: "ShareButton",
  actionLabel: "Share",
  elementPanelSettings: {
    displayName: "Share Button",
    displayIcon: "hugeicons:share-01",
    elementGroup: "storyElements",
  },
  extends: DynamicComponentActionElement,
  mixins: [StoryPageElementMixin, EngagementActionMixin],
  optionBundles: [
    new ButtonActionOptions({ "default.icon": ENGAGEMENT_ICONS.share }),
  ],
  data() {
    return {
      isShareConfirmed: false,
    };
  },
  computed: {
    suppressPaddingAdjustment() {
      return true;
    },
    isEngagementActive() {
      return this.isShareConfirmed;
    },
    engagementActiveIcon() {
      return ENGAGEMENT_ICONS.shared;
    },
    myValue() {
      return this.myDisplayValue === "show" ? this.entity?.shareCount ?? 0 : "";
    },
    shouldShowAction() {
      return true;
    },
  },
  methods: {
    handleClick() {
      if (this.editMode || this.isPreviewMode) {
        return;
      }
      const storyId = this.storyEntityId;
      shareStory(storyId, { title: this.entity.title, url: `${this.links.web}/story/${storyId}` }, () => {
        this.isShareConfirmed = true;
        setTimeout(() => {
          this.isShareConfirmed = false;
        }, SHARE_CONFIRMATION_MS);
      });
    },
  },
};
</script>
